<template>
  <div>
    <b-row>
      <b-col md="12">
        <b-card>
          <template #default>
            <h3 class="text-center w-100">
              {{ $t('reply.posts-page-title',{page:currentPage.name}) }}
            </h3>
          </template>
        </b-card>
        <fetching-data-spinner
          :error="error"
          :loading="loading"
          :loading-title="$t('reply.loading-posts')"
          enable-retry
          @retry="fetchPosts"
        />
      </b-col>
      <template v-if="!loading && !error">
        <b-col
          v-for="post in posts"
          :key="post.id"
          xl="4"
          md="6"
          xxs="12"
        >
          <b-card
            no-body
            class="mb-2"
          >
            <div
              v-if="post.media_type==='VIDEO'"
              style="height: 200px;width: 100%"
            >
              <ok-video-player

                :src="post.picture"
                compact
              />
            </div>
            <div
              v-else
              v-lazy:background-image="post.picture"
              style="background-size: cover;height: 200px;background-position: center;width: 100%"
            />

            <b-card-body>
              <div class="d-flex justify-content-between">
                <span>
                  <FeatherIcon
                    size="20"
                    fill="#827F8D"
                    class="text-white ml-10"
                    icon="ClockIcon"
                  />
                  <i
                    class="text-muted"
                    style="margin-right: 3px; font-size: 12px"
                  >{{ post.created_at }}</i>

                </span>
                <div>
                  <span class="mr-50">
                    <i class="ml-10">{{ post.comments_count }}</i>
                    <FeatherIcon
                      size="20"
                      fill="#0D8BF1"
                      class="text-white"
                      icon="MessageCircleIcon"
                    />
                  </span>
                  <span>
                    <i class="ml-10">{{ post.like_count }}</i>
                    <FeatherIcon
                      size="20"
                      fill="#FB160A"
                      class="text-white"
                      icon="HeartIcon"
                    />
                  </span>

                </div>
              </div>
              <h5 class="mb-0 mt-1 text-center">
                {{ post.caption?post.caption:$t('general.no-text') }}
              </h5>
              <hr>
              <div class="d-flex justify-content-between align-items-center">
                <h5>{{ $t('instagram.comment-reply') }}</h5>
                <div v-if="post.enabled">
                  <b-button
                    v-b-tooltip.hover
                    variant="warning"
                    size="sm"
                    :title="$t('reply.edit')"
                    class="btn-icon"
                    @click="goEdit(post)"
                  >
                    <FeatherIcon icon="EditIcon" />
                  </b-button>
                  <b-button
                    v-b-tooltip.hover
                    variant="danger"
                    size="sm"
                    class="btn-icon ml-50"
                    :title="$t('reply.delete')"
                    @click="handleDelete(post)"
                  >
                    <FeatherIcon icon="TrashIcon" />
                  </b-button>
                </div>
                <b-button
                  v-else
                  v-b-tooltip.hover
                  :title="$t('reply.enable')"
                  variant="success"
                  size="sm"
                  class="btn-icon"
                  @click="goNew(post)"
                >
                  <FeatherIcon icon="PlusIcon" />
                </b-button>
              </div>
              <div class="d-flex justify-content-between align-items-center mt-1">
                <h5>{{ $t('instagram.media-settings') }}</h5>
                <div>
                  <b-button
                    v-b-tooltip.hover
                    :title="$t('instagram.media-analytic')"
                    variant="success"
                    size="sm"
                    class="btn-icon"
                    @click="showInsight(post)"
                  >
                    <FeatherIcon icon="BarChart2Icon" />
                  </b-button>
                  <b-button
                    v-b-tooltip.hover
                    :title="getCommentLabel(post.is_comment_enabled)"
                    :variant="post.is_comment_enabled?'danger':'success'"
                    size="sm"
                    class="btn-icon ml-50"
                    @click="handleComment(post)"
                  >
                    <FeatherIcon :icon="post.is_comment_enabled?'DeleteIcon':'MessageSquareIcon'" />
                  </b-button>
                </div>
              </div>
              <hr>
              <div class="d-flex justify-content-between align-items-center mt-1">
                <a
                  class="btn btn-sm btn-primary"
                  target="_blank"
                  :href="post.permalink"
                  @click="(post)"
                >
                  <FeatherIcon icon="ExternalLinkIcon" />
                  {{ $t('instagram.visit-post') }}
                </a>
                <b-button
                  variant="primary"
                  size="sm"
                  @click="showComment(post)"
                >
                  <FeatherIcon icon="Edit3Icon" />
                  {{ $t('instagram.add-comment') }}
                </b-button>
              </div>
            </b-card-body>
          </b-card>
        </b-col>
      </template>
    </b-row>
    <insights-modal
      v-model="showInsightModal"
      :post="selectedPost"
    />
    <comment-modal
      v-model="showCommentModal"
      :post="selectedPost"
      @commented="increaseComments"
    />
  </div>
</template>

<script>
import {
  BRow, BCol, BCard, BButton, VBTooltip, BCardBody,
} from 'bootstrap-vue'
import { mapGetters } from 'vuex'
import FetchingDataSpinner from '@/@bya3/components/utils/FetchingDataSpinner'
import InstagramReplyApi from '@/api/instagram/reply'
import InstagramMediaApi from '@/api/instagram/media'
import InsightsModal from '@/views/owner-instagram/account/components/InsightModal'
import CommentModal from '@/views/owner-instagram/account/components/CommentModal'
import OkVideoPlayer from '@/@bya3/components/media/OkVidePlayer.vue'

export default {
  components: {
    OkVideoPlayer,
    CommentModal,
    InsightsModal,
    FetchingDataSpinner,
    BRow,
    BCol,
    BCard,
    BButton,
    BCardBody,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  data() {
    return {
      posts: [],
      error: null,
      loading: true,
      showInsightModal: false,
      showCommentModal: false,
      selectedPost: null,
    }
  },
  computed: {
    ...mapGetters({
      currentPageId: 'instagram/currentAccountId',
      currentPage: 'instagram/currentAccount',
    }),
  },
  watch: {
    currentPageId() {
      this.fetchPosts()
    },
  },

  mounted() {
    this.fetchPosts()
  },
  methods: {
    showInsight(post) {
      this.showInsightModal = true
      this.selectedPost = post
    },
    increaseComments() {
      const index = this.posts.findIndex(post => post.id === this.selectedPost.id)
      if (index > -1) {
        this.posts[index].comments_count += 1
      }
    },
    showComment(post) {
      this.showCommentModal = true
      this.selectedPost = post
    },
    async fetchPosts() {
      this.loading = true
      try {
        // For direct Instagram accounts, page is null, so use account_id or 0 as pageId
        const pageId = this.currentPage.page?.id ?? null
        const res = await InstagramMediaApi.postsList(pageId, this.currentPage.id)
        if (res.error === 0) this.posts = res.posts
        else {
          this.error = res.message
        }
      } catch (e) {
        this.error = e
      } finally {
        this.loading = false
      }
    },
    handleDelete(post) {
      this.$okConfirm(this.$t('reply.delete-reply-message'), {
        preConfirm: () => InstagramReplyApi.deleteReply(post.id)
          .then(response => {
            this.$notifySuccess(response.message)
            const index = this.posts.findIndex(p => p.id === post.id)
            if (index > -1) this.posts[index].enabled = false
          })
          .catch(e => this.$notifyError(e)),
      })
    },
    getCommentLabel(currentStatus) {
      const submit = currentStatus ? 'disable' : 'enable'
      return this.$t(`instagram.${submit}-commenting`)
    },
    handleComment(post) {
      const submit = post.is_comment_enabled ? 'disable' : 'enable'
      this.$okConfirm(this.$t(`instagram.${submit}-commenting-msg`), {
        confirmButtonText: this.$t(`instagram.${submit}-commenting`),
        preConfirm: () => InstagramReplyApi.enableDisableComment(this.currentPageId, { media_id: post.id, enable: !post.is_comment_enabled })
          .then(response => {
            if (response?.error === 1) {
              this.$notifyError(response.message)
            } else {
              this.$notifySuccess(response.message)
              const index = this.posts.findIndex(p => p.id === post.id)
              if (index > -1) this.posts[index].is_comment_enabled = !post.is_comment_enabled
            }
          })
          .catch(e => this.$notifyError(e)),
      })
    },
    goEdit(post) {
      this.$store.commit('reply/SET_FORM', { post_description: post?.caption ?? '', post_thumb: post.picture })
      this.$router.push({ name: 'owner:instagram-reply-edit', params: { id: post.id } })
    },
    goNew(post) {
      this.$store.commit('reply/SET_FORM', { post_description: post?.caption ?? '', post_thumb: post.picture })
      this.$router.push({ name: 'owner:instagram-reply', params: { id: post.id } })
    },
  },
}
</script>
